import {CreateInstance} from './config'
const deviceGroupAPI = CreateInstance('device-groups')
export const deviceGroupHashAPI = CreateInstance('device_group_hash')

export default deviceGroupAPI